<template>
  <div id="saleDetails">
    <div class="section">
      <div class="item" v-for="item of sale.items">
        <label v-if="isPayment(item)">{{$t('reception.payment')}}</label>
        <label v-else-if="isUserComment(item)">{{$t('reception.userComment')}}</label>
        <label v-else-if="isNote(item)">{{$t('reception.note')}}</label>
        <label v-else>{{$t('reception.product')}}</label>
        <div class="top">
          <span class="name">{{isProduct(item) || item.quantity > 1 ? `${item.quantity}x ` : ''}}{{item.name}}</span>
          <span class="price" v-if="isProduct(item) || item.price > 0">{{$tc(item.price, sale.currency)}}</span>
        </div>
        <label v-if="item.combos.length > 0">{{$t('reception.selection')}}</label>
        <div class="combos">
          <div class="combo" v-for="combo of item.combos">
            <span class="name">{{combo.quantity > 1 ? `${combo.quantity}x ` : ''}}{{combo.name}}</span>
            <span class="price" v-if="combo.price > 0">{{$tc(combo.price, sale.currency)}}</span>
          </div>
        </div>
        <label v-if="combinedExtras(item).length > 0 && isProduct(item)">{{$t('reception.extra')}}</label>
        <div class="extras">
          <div class="extra" :class="{itemWeight: isPayment(item)}" v-for="extra of combinedExtras(item)">
            <span class="name">{{extra.name}} {{extra.quantity > 1 ? ` (${extra.quantity})` : ''}}</span>
            <span class="price" v-if="extra.price > 0">{{$tc(extra.price, sale.currency)}}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="item supplement" v-for="supplement of sale.supplements">
      <span class="name">{{supplement.name}}</span>
    </div>
  </div>
</template>

<script>
  export default {
    name: "saleDetails",

    props: {
      sale: Object
    },

    methods: {
      combinedExtras(item) {
        let extras = [];

        for (let extra of item.extras) {
          let found = extras.find(e => e.name === extra.name);
          if (found) {
            found.quantity += extra.quantity;
            found.price += extra.price;
          } else {
            extras.push(this.copy(extra));
          }
        }

        return extras;
      },

      copy(object) {
        return JSON.parse(JSON.stringify(object));
      },

      isProduct(item) {
        return !item.type || item.type === 'product';
      },

      isPayment(item) {
        return item.type === 'payment';
      },

      isUserComment(item) {
        return item.type === 'userComment';
      },

      isNote(item) {
        return item.type === 'note';
      }
    }
  }
</script>

<style lang="scss" scoped>
  .section {
    display: flex;
    flex-wrap: wrap;
    flex-grow: 1;
  }

  .item {
    flex-grow: 1;
    flex-shrink: 1;
    font-size: 13px;
    border: 1px solid #d9d9d9;
    padding: 8px;
    border-radius: 5px;

    &:not(:last-child) {
      margin-bottom: 8px;
    }

    .top {
      display: flex;
      font-size: 15px;
      justify-content: space-between;
      font-weight: 500;
    }
  }

  label {
    font-size: 12px;
    &:not(:first-child) {
      margin-top: 8px;
    }
  }

  .combo, .extra {
    display: flex;
    justify-content: space-between;
  }

  .itemWeight {
    font-size: 15px;
    font-weight: 500;
  }

  .price {
    white-space: nowrap;
  }
</style>
